/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../../Fixes';
import Builder from '../../../../../../../Builder';
import '../../../../../product_type';
import '../../../../../../devices/external/application_type';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "settings": {
                        "nested": {
                          "kds": {
                            "nested": {
                              "KDSFetchSettings": {
                                "fields": {
                                  "categories": {
                                    "type": "squareup.devicesettings.profiles.v2.model.settings.kds.KDSFetchSettings.CategoryConfiguration",
                                    "id": 1,
                                    "rule": "repeated"
                                  },
                                  "uncategorizedEnabled": {
                                    "type": "bool",
                                    "id": 2,
                                    "rule": "optional",
                                    "options": {
                                      "default": true
                                    }
                                  },
                                  "includeFutureCategoriesEnabled": {
                                    "type": "bool",
                                    "id": 3,
                                    "rule": "optional",
                                    "options": {
                                      "default": true
                                    }
                                  },
                                  "ordersEnabled": {
                                    "type": "bool",
                                    "id": 4,
                                    "rule": "optional",
                                    "options": {
                                      "default": true
                                    }
                                  },
                                  "displayOrderOnState": {
                                    "type": "squareup.devicesettings.profiles.v2.model.settings.kds.KDSFetchSettings.DisplayOrderConfigurationState",
                                    "id": 5,
                                    "rule": "optional",
                                    "options": {
                                      "default": "ON_PLACED"
                                    }
                                  },
                                  "stationOnPickupBufferSeconds": {
                                    "type": "int32",
                                    "id": 6,
                                    "rule": "optional",
                                    "options": {
                                      "default": 900
                                    }
                                  },
                                  "posEnabled": {
                                    "type": "bool",
                                    "id": 7,
                                    "rule": "optional",
                                    "options": {
                                      "default": true
                                    }
                                  },
                                  "posDeviceConfigurations": {
                                    "type": "squareup.devicesettings.profiles.v2.model.settings.kds.KDSFetchSettings.POSDeviceConfiguration",
                                    "id": 8,
                                    "rule": "repeated"
                                  },
                                  "includeFutureNamedPosEnabled": {
                                    "type": "bool",
                                    "id": 9,
                                    "rule": "optional",
                                    "options": {
                                      "default": true
                                    }
                                  },
                                  "includeUnnamedPosEnabled": {
                                    "type": "bool",
                                    "id": 10,
                                    "rule": "optional",
                                    "options": {
                                      "default": true
                                    }
                                  },
                                  "coursingDisplayType": {
                                    "type": "squareup.devicesettings.profiles.v2.model.settings.kds.KDSFetchSettings.CoursingDisplayType",
                                    "id": 11,
                                    "rule": "optional",
                                    "options": {
                                      "default": "SHOW_HELD_AND_FIRED_COURSES"
                                    }
                                  },
                                  "includeFutureDiningOptionsEnabled": {
                                    "type": "bool",
                                    "id": 12,
                                    "rule": "optional",
                                    "options": {
                                      "default": true
                                    }
                                  },
                                  "diningOptionConfigurations": {
                                    "type": "squareup.devicesettings.profiles.v2.model.settings.kds.KDSFetchSettings.DiningOptionConfiguration",
                                    "id": 13,
                                    "rule": "repeated"
                                  },
                                  "useSingleStationCompletion": {
                                    "type": "bool",
                                    "id": 14,
                                    "rule": "optional",
                                    "options": {
                                      "default": false
                                    }
                                  },
                                  "deviceIdRoutingConfiguration": {
                                    "type": "squareup.devicesettings.profiles.v2.model.settings.kds.KDSFetchSettings.DeviceIdRoutingConfiguration",
                                    "id": 15,
                                    "rule": "optional"
                                  },
                                  "stationType": {
                                    "type": "squareup.devicesettings.profiles.v2.model.settings.kds.KDSFetchSettings.StationType",
                                    "id": 16,
                                    "rule": "optional",
                                    "options": {
                                      "default": "PREP"
                                    }
                                  }
                                },
                                "nested": {
                                  "CategoryConfiguration": {
                                    "fields": {
                                      "catalogObjectId": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                      },
                                      "enabled": {
                                        "type": "bool",
                                        "id": 2,
                                        "rule": "optional"
                                      },
                                      "isKitchen": {
                                        "type": "bool",
                                        "id": 3,
                                        "rule": "optional"
                                      },
                                      "displayName": {
                                        "type": "string",
                                        "id": 4,
                                        "rule": "optional"
                                      }
                                    }
                                  },
                                  "DisplayOrderConfigurationState": {
                                    "values": {
                                      "DISPLAY_ORDER_CONFIGURATION_STATE_EVENT_DO_NOT_USE": 0,
                                      "ON_NEW": 1,
                                      "ON_MARKED_IN_PROGRESS": 2,
                                      "ON_PLACED": 3,
                                      "ON_PICKUP_WITH_BUFFER": 4
                                    }
                                  },
                                  "POSDeviceConfiguration": {
                                    "fields": {
                                      "deviceCredentialId": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                      },
                                      "enabled": {
                                        "type": "bool",
                                        "id": 2,
                                        "rule": "optional"
                                      },
                                      "displayName": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                      },
                                      "productType": {
                                        "type": "squareup.devicesettings.ProductType",
                                        "id": 4,
                                        "rule": "optional"
                                      }
                                    }
                                  },
                                  "CoursingDisplayType": {
                                    "values": {
                                      "COURSING_TYPE_DO_NOT_USE": 0,
                                      "SHOW_FIRED_COURSES_ONLY": 1,
                                      "SHOW_HELD_AND_FIRED_COURSES": 2
                                    }
                                  },
                                  "DiningOptionConfiguration": {
                                    "fields": {
                                      "catalogObjectId": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                      },
                                      "selected": {
                                        "type": "bool",
                                        "id": 2,
                                        "rule": "optional"
                                      },
                                      "displayName": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                      }
                                    }
                                  },
                                  "DeviceIdRoutingConfiguration": {
                                    "fields": {
                                      "includeFuturePosDeviceEnabled": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                      },
                                      "posRoutingConfigurations": {
                                        "type": "squareup.devicesettings.profiles.v2.model.settings.kds.KDSFetchSettings.POSDeviceRoutingConfiguration",
                                        "id": 2,
                                        "rule": "repeated"
                                      }
                                    }
                                  },
                                  "POSDeviceRoutingConfiguration": {
                                    "fields": {
                                      "deviceId": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                      },
                                      "deviceCredentialToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                      },
                                      "enabled": {
                                        "type": "bool",
                                        "id": 3,
                                        "rule": "optional"
                                      },
                                      "displayName": {
                                        "type": "string",
                                        "id": 4,
                                        "rule": "optional"
                                      },
                                      "posApplicationType": {
                                        "type": "squareup.connect.v2.ApplicationType",
                                        "id": 5,
                                        "rule": "optional"
                                      }
                                    }
                                  },
                                  "StationType": {
                                    "values": {
                                      "STATION_TYPE_DO_NOT_USE": 0,
                                      "PREP": 1,
                                      "FIRST_STAGE_EXPO": 2
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.kds?.nested?.KDSFetchSettings && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.kds?.nested?.KDSFetchSettings?.nested?.CategoryConfiguration && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.kds?.nested?.KDSFetchSettings?.nested?.DisplayOrderConfigurationState && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.kds?.nested?.KDSFetchSettings?.nested?.POSDeviceConfiguration && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.kds?.nested?.KDSFetchSettings?.nested?.CoursingDisplayType && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.kds?.nested?.KDSFetchSettings?.nested?.DiningOptionConfiguration && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.kds?.nested?.KDSFetchSettings?.nested?.DeviceIdRoutingConfiguration && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.kds?.nested?.KDSFetchSettings?.nested?.POSDeviceRoutingConfiguration && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.kds?.nested?.KDSFetchSettings?.nested?.StationType) {
  $root.addJSON(jsonData);
}

/**
 * import "squareup/devicesettings/product_type.proto";
 * The settings for fetching chits on the KDS
 *
 * SOURCE KDSFetchSettings @ squareup/devicesettings/profiles/v2/model/settings/kds/kds_fetch_settings.proto at 14:1
 */
export const KDSFetchSettings = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.kds.KDSFetchSettings');
fixType(KDSFetchSettings);
Builder.createAndAttachToType(KDSFetchSettings);
/**
 * SOURCE CategoryConfiguration @ squareup/devicesettings/profiles/v2/model/settings/kds/kds_fetch_settings.proto at 19:3
 */
KDSFetchSettings.CategoryConfiguration = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.kds.KDSFetchSettings.CategoryConfiguration');
fixType(KDSFetchSettings.CategoryConfiguration);
Builder.createAndAttachToType(KDSFetchSettings.CategoryConfiguration);
/**
 * SOURCE DisplayOrderConfigurationState @ squareup/devicesettings/profiles/v2/model/settings/kds/kds_fetch_settings.proto at 48:3
 */
KDSFetchSettings.DisplayOrderConfigurationState = $root.lookupEnum('squareup.devicesettings.profiles.v2.model.settings.kds.KDSFetchSettings.DisplayOrderConfigurationState').values;
/**
 * Represents filtering configuration for one POS client signed in by device code.
 *
 * SOURCE POSDeviceConfiguration @ squareup/devicesettings/profiles/v2/model/settings/kds/kds_fetch_settings.proto at 73:3
 */
KDSFetchSettings.POSDeviceConfiguration = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.kds.KDSFetchSettings.POSDeviceConfiguration');
fixType(KDSFetchSettings.POSDeviceConfiguration);
Builder.createAndAttachToType(KDSFetchSettings.POSDeviceConfiguration);
/**
 * SOURCE CoursingDisplayType @ squareup/devicesettings/profiles/v2/model/settings/kds/kds_fetch_settings.proto at 110:3
 */
KDSFetchSettings.CoursingDisplayType = $root.lookupEnum('squareup.devicesettings.profiles.v2.model.settings.kds.KDSFetchSettings.CoursingDisplayType').values;
/**
 * SOURCE DiningOptionConfiguration @ squareup/devicesettings/profiles/v2/model/settings/kds/kds_fetch_settings.proto at 126:3
 */
KDSFetchSettings.DiningOptionConfiguration = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.kds.KDSFetchSettings.DiningOptionConfiguration');
fixType(KDSFetchSettings.DiningOptionConfiguration);
Builder.createAndAttachToType(KDSFetchSettings.DiningOptionConfiguration);
/**
 * SOURCE DeviceIdRoutingConfiguration @ squareup/devicesettings/profiles/v2/model/settings/kds/kds_fetch_settings.proto at 145:3
 */
KDSFetchSettings.DeviceIdRoutingConfiguration = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.kds.KDSFetchSettings.DeviceIdRoutingConfiguration');
fixType(KDSFetchSettings.DeviceIdRoutingConfiguration);
Builder.createAndAttachToType(KDSFetchSettings.DeviceIdRoutingConfiguration);
/**
 * SOURCE POSDeviceRoutingConfiguration @ squareup/devicesettings/profiles/v2/model/settings/kds/kds_fetch_settings.proto at 150:3
 */
KDSFetchSettings.POSDeviceRoutingConfiguration = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.kds.KDSFetchSettings.POSDeviceRoutingConfiguration');
fixType(KDSFetchSettings.POSDeviceRoutingConfiguration);
Builder.createAndAttachToType(KDSFetchSettings.POSDeviceRoutingConfiguration);
/**
 * SOURCE StationType @ squareup/devicesettings/profiles/v2/model/settings/kds/kds_fetch_settings.proto at 170:3
 */
KDSFetchSettings.StationType = $root.lookupEnum('squareup.devicesettings.profiles.v2.model.settings.kds.KDSFetchSettings.StationType').values;